import Popover from "@mui/material/Popover";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import React, {Fragment, useEffect, useState} from "react";
import {IDataSpell} from "../_interfaces/IDataSpell";
import {v4} from "uuid";
import {InfoSpellSubscriber} from "../_helper/InfoSpellBehave";
import {Typography} from "@mui/material";


function SpellPopover() {

    const [infoSpell, setInfoSpell] = useState<IDataSpell | null>(null);
    const [infoSpellAncor, setInfoSpellAncor] = useState<Element | HTMLElement | null>(null);
    const [infoSpellOpen, setInfoSpellOpen] = useState(false);

    useEffect(() => {
        const subscription = InfoSpellSubscriber.subscribe((newValue) => {
            setInfoSpell(newValue.pop);
            setInfoSpellAncor(newValue.popEl)
            setInfoSpellOpen(newValue.popOpen)
        });

        return () => {
            subscription.unsubscribe();
        };
    }, []);

    const handleClose = () => {
        setInfoSpell(null);
        setInfoSpellAncor(null)
        setInfoSpellOpen(false);
    }

    if (infoSpellOpen) return <Popover
        open={infoSpellOpen}
        anchorEl={infoSpellAncor}
        onClose={handleClose}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }}
    >
        <Grid container spacing={1} style={{padding: 10}}>
            <Grid item xs={10}>
                <Typography variant={'h4'}>{infoSpell!.name}</Typography>
            </Grid>
            <Grid item xs={2}>
                <Button onClick={() => handleClose()}>X</Button>
            </Grid>
            <Grid item xs={12}>
                <Typography variant={'h6'}>Disziplin: {infoSpell!.discipline} Kreis: {infoSpell!.circle}</Typography>
            </Grid>
            <Grid item xs={4}>
                <Typography variant={'h6'}>Fäden: {infoSpell!.threads}</Typography>
            </Grid>
            <Grid item xs={4}>
                <Typography variant={'h6'}>Webschwierigkeit: {infoSpell!.weaving}/{infoSpell!.attune}</Typography>
            </Grid>
            <Grid item xs={4}>
                <Typography variant={'h6'}>Wirkschwierigkeit: {infoSpell!.casting}</Typography>
            </Grid>
            <Grid item xs={4}>
                <Typography variant={'h6'}>Reichweite: {infoSpell!.distance}</Typography>
            </Grid>
            <Grid item xs={4}>
                <Typography variant={'h6'}>Wirkungsdauer: {infoSpell!.dur}</Typography>
            </Grid>
            <Grid item xs={4}>
                <Typography variant={'h6'}>Wirkung: {infoSpell!.eff}</Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography variant={'h6'}>Beschreibung:</Typography>
                {infoSpell!.desc && infoSpell!.desc.map(desc =>
                    <Typography variant={'body2'} key={v4()}>
                        {desc}
                    </Typography>)}
            </Grid>
            <Grid item xs={12}>
                <Grid container>
                    <Grid item xs={3}>
                        <Typography variant={'h6'}>Zusätzliche Erfolge</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        {infoSpell!.as ?
                            <Typography variant={'body2'} key={v4()}>{infoSpell!.as.txt}</Typography>
                            : null}
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Grid container>
                    <Grid item xs={3}>
                        <Typography variant={'h6'}>Zusätzliche Fäden</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        {infoSpell?.at ?
                            infoSpell.at.map(at =>
                                <Typography variant={'body2'} key={v4()}>
                                    {at.txt}
                                </Typography>)
                            : null}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    </Popover>

    else return <Fragment/>
}

export default SpellPopover;